import React from 'react';
import { connect } from 'react-redux';
import { Context } from '@leverege/plugin';
import SelectionModel from "./SelectionModel.js";
import { SelectionFactory } from "./Factory.js";
import Style from "../shared/Style.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  getOuterStyle,
  getInnerStyle
} = Style;
function SelectionCard(props) {
  const {
    model,
    context,
    controls,
    headerControls,
    footerControls,
    onClose
  } = props;

  // Get Target Type(s)
  const types = Context.getTargetTypes(context);
  if (types == null || types.length === 0) {
    return null;
  }
  let type = 'object[]';
  if (types.length === 1) {
    type = Array.isArray(context.target) && context.target.length === 1 ? types[0] : `${types[0]}[]`;
  }

  // Get DetailModel for the Type(s)
  const typeModel = SelectionModel.getType(model, type);
  if (typeModel == null || typeModel.visible === false) {
    return null;
  }
  const placement = SelectionModel.getPlacementForType(model, type);
  const margin = typeModel.margin || model.margin || '16px';

  // Otherwise, position it at the desirec screen position
  return /*#__PURE__*/_jsx("div", {
    style: getOuterStyle(placement, margin),
    children: /*#__PURE__*/_jsx("div", {
      style: getInnerStyle(placement, margin),
      children: SelectionFactory.create(typeModel.details, {
        context,
        headerControls: headerControls || controls,
        footerControls,
        onClose
      })
    })
  });
}
const EMPTY = {};
export default connect((state, props) => {
  const model = props.model || EMPTY; // get from Rsrc if model not supplied

  return {
    model
  };
})(SelectionCard);